import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { ApiResponseObject } from '../models/responses/api-response-object';
import { Injectable } from '@angular/core';
import { LocationDto } from '../models/LocationDto';
import { LocationRequest } from '../models/requests/location-request';



@Injectable({
  providedIn: 'root'
})
export class AxiomsService {

  constructor(private httpClient: HttpClient) { }

  getAxioms(): Observable<ApiResponseObject<LocationDto[]>> {
    ;
    return this.httpClient.get<ApiResponseObject<LocationDto[]>>(`${environment.apiUrl}/Axiom`);
  }
 
  saveAxiom(request: LocationRequest): Observable<ApiResponseObject<LocationDto>> {
   
    return this.httpClient.post<ApiResponseObject<LocationDto>>(`${environment.apiUrl}/Axiom`, request);
  }
}
